<template>
  <div class="kyc-manual-review-notice">
    <div class="content">
      <!-- eslint-disable vue/no-v-html -->
      <!-- Since the values used in this component are hardcoded in useKYC, we can use v-html safely-->
      <h1>Thank you for submitting your documents</h1>
      <p>
        Our team is currently reviewing your submitted documents. If you have
        any questions, please reach out to
        <u><a href="mailto:support@cloaked.com">support@cloaked.com</a></u>
        . As a reminder, we have asked for one of the following documents from
        each category:
      </p>
      <!-- eslint-enable vue/no-v-html -->

      <div
        v-if="docSections.length > 0"
        class="document-categories"
      >
        <div
          v-for="(docs, index) in docSections"
          :key="index"
          class="category-section"
        >
          <ul>
            <li
              v-for="(doc, docIndex) in docs"
              :key="doc"
            >
              <span
                v-if="docIndex > 0"
                class="or-prefix"
              >
                <i><b>OR</b></i>
              </span>
              <span>
                {{ doc }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useKYC } from "@/composables/useKYC";

const props = defineProps({
  edd: {
    type: Object,
    required: true,
  },
});

const { getEddDocumentsDescriptions } = useKYC();

// Generate manual review cells from required documents
const docSections = computed(() => {
  const requiredDocuments = props.edd?.required_documents || [];
  if (requiredDocuments.length === 0) {
    return [];
  }
  return getEddDocumentsDescriptions(requiredDocuments);
});
</script>

<style scoped lang="scss">
.kyc-manual-review-notice {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 1;
  padding: 40px 20px;

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    max-width: 800px;
    width: 100%;

    h1 {
      font-family: Urbanist;
      font-size: 48px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-bottom: 27px;
      color: $color-primary-100;
    }

    p {
      color: $color-primary-100;
      font-family: Urbanist;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%; /* 22.4px */
    }

    .document-categories {
      display: flex;
      flex-direction: column;
      align-self: stretch;
      margin-top: 24px;

      .category-section {
        ul {
          list-style-type: disc;
          padding-left: 20px;
          color: $color-primary-100;
          font-family: Urbanist;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 140%; /* 22.4px */

          .or-prefix {
            margin-right: 4px;
          }
        }

        // Add line separator between categories (not after the last one)
        &:not(:last-child) {
          border-bottom: 1px solid $color-primary-10;
          padding-bottom: 24px;
          margin-bottom: 24px;
        }
      }
    }
  }
}
</style>
